<template>
  <base-section
    id="hotel-rooms"
  >
  <v-container>
    <base-section-heading
        title="Location Overview"
    >
    <div style="text-align: left !important">
	ETS23 is located on San Servolo Island. Venice is composed of many islands distributed in a large lagoon. San Servolo is located in the southeast part of the Venice lagoon archipelago, 10-minute boat trip from San Marco Quartier.
    <br><br>
    Line 20, Public Transportation boats sails to the San Servolo Island from the San Zaccaria – pier “B” which is close to San Marco Square (<a href="https://www.google.it/maps/place/S.+Marco-San+Zaccaria+%22B%22/@45.4334878,12.3421963,17z/data=!4m6!3m5!1s0x477eae28703f142d:0xee681e0817adb337!8m2!3d45.433666!4d12.34424!16s%2Fg%2F11j64v2fv0">pier location</a>).
    <br><br>
    </div>
        <v-img
        :src="require('@/assets/tips.png')"
        >
        </v-img>
    </base-section-heading>
    <base-section-heading
      title="Hotel Suggestions"
    >
    <div style="text-align: left !important">
    The Hotel Rooms at San Servolo Island are <strong><u>no more available</u></strong>. All rooms have already been booked.<br>
    <br>
    - The best connected area with San Servolo is certainly <strong>San Marco (San Zaccaria stop)</strong>, which has many hotels. Here are some hotels in the area, all within walking distance of San Zaccaria:<br>
    &emsp;• Hotel Panada: <a href="http://www.hotelpanada.it/it/location.htm">http://www.hotelpanada.it/it/location.htm</a><br>
    &emsp;• University Hotel: <a href="https://ateneo.it/rooms/?lang=en">https://ateneo.it/rooms/?lang=en</a><br>
    &emsp;• Hotel Ca Alvise: <a href="http://www.caalvisehotelvenice.com/index.htm?lbl=ggl-en-rsp&gclid=Cj0KCQjwhqaVBhCxARIsAHK1tiNXyeFuoyNn92fpSMOh6OM7nEUv4Bj-BYMd5AjPPUb8HaPhklxlRacaAvSwEALw_wcB">http://www.caalvisehotelvenice.com/index.htm?lbl=ggl-en-rsp&gclid=Cj0KCQjwhqaVBhCxARIsAHK1tiNXyeFuoyNn92fpSMOh6OM7nEUv4Bj-BYMd5AjPPUb8HaPhklxlRacaAvSwEALw_wcB</a><br>
    &emsp;• A la Commedia Hotel: <a href="https://www.commediahotel.com/">https://www.commediahotel.com/</a><br>
    -	Alternatively, you can think of the area near the <strong>Zattere stop</strong> from which two direct morning trips leave for San Servolo. On the way back, however, you have to change the vaporetto at San Marco (with line 2). If you want to go on foot you have to consider about 20 minutes of walking in one of the most beautiful areas of the city. Here some tips:<br>
    &emsp;• Domus Ciliota: <a href="https://www.ciliota.it/en/">https://www.ciliota.it/en/</a><br>
    &emsp;• Hotel Belle Arti: <a href="https://www.hotelbelleartivenice.com/italian/">https://www.hotelbelleartivenice.com/italian/</a><br>
    &emsp;• Hotel Messner: <a href="https://www.hotelmessner.com/hotelmessner/">https://www.hotelmessner.com/hotelmessner/</a><br>
    </div>
    </base-section-heading>
    <base-section-heading
      title="Still loking for an hotel?"
    >
    <div style="text-align: left !important">
    If you are still looking for a convenient hotel in terms of prices and position in Venice, we suggest you consider the list of hotels on the Expedia page (<a href="https://cas.polito.it/ETS23/#/venue">venue page</a>).
    <br><br>
    San Marco Quartier and Lido di Venezia are close and connected directly to San Servolo and are the best locations for an accommodation that is easy to reach. You may also use this link to Expedia to search for a single room from 22nd to 25th May <a
    target="_blank"
    href="https://www.expedia.it/Hotel-Search?adults=1&children=&d1=2023-05-22&d2=2023-05-25&destination=Venezia%20%28e%20dintorni%29%2C%20Veneto%2C%20Italia&endDate=2023-05-25&latLong=&mapBounds=&neighborhood=179981&poi=45.434148%2C12.338622%3A503200&pwaDialog&pwaOverlay=map&regionId=179981&rooms=1&semdtl=&sort=RECOMMENDED&startDate=2023-05-22&theme=&useRewards=false&userIntent="
    >(link to expedia page)</a>.
    <br><br>
    Mestre Quartier is on the land and quite far from San Marco and San Servolo. Therefore, you can find a lot of very cheap hotels there. The connection from Mestre to Venice Train station is quite fast (20 minutes) and frequent especially in the morning, and you need to account for about 30/40 minutes more to reach San Servolo from the Santa Lucia train station.
    <br><br>
    May is considered a very high seasonal period in Venice because of the mild temperature and the many events the city hosts; we suggest you do not delay too much to look for your room.
    </div>
    <br><br><br>
    <strong><span style="font-size: 1.5rem !important">We look forward to receiving you shortly in Venice!!</span></strong>
    </base-section-heading>
      <br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in venuefooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < venuefooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'HotelRooms',
    data: () => ({
      isMobile: false,
      venuefooter: [
        {
          name: 'City of Venice',
          url: 'venice',
        },
        {
          name: 'Congress Center',
          url: 'congress-center',
        },
        {
          name: 'Hotel Rooms',
          url: 'hotel-rooms',
        },
        {
          name: 'Visa',
          url: 'visa',
        },
      ],
      slides: [
        {
          title: 'Double Deluxe Superior Room – Lagoon view',
          src: require('@/images/Double Deluxe Superior room - lagoon view.jpg'),
          desc: 'King size bed – max occupancy 2 persons',
          price: 'Price per night: 148,75€',
          overlay: false,
        },
        {
          title: 'Junior Suite',
          src: require('@/images/Junior Suite.jpg'),
          desc: 'King size bed – max occupancy 2 persons',
          price: 'Price per night: 170€',
          overlay: false,
        },
        {
          title: 'Double Room',
          src: require('@/images/Double Room.jpg'),
          desc: 'Two single beds– max occupancy 2 persons',
          price: 'Price per night: 127,50€',
          overlay: false,
        },
        {
          title: 'Single Room',
          src: require('@/images/Single Room.jpg'),
          price: 'Price per night: 80,75€',
          overlay: false,
        },
        {
          title: 'Triple Room (double use)',
          src: require('@/images/Triple Room.jpg'),
          price: 'Price per night: 127,50€',
          overlay: false,
        },
        {
          title: 'Triple Room (triple use)',
          src: require('@/images/Triple Room.jpg'),
          price: 'Price per night: 148,50€',
          overlay: false,
        },
      ],
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
<style>
.v-btn__content {
  width: 100%;
  white-space: break-spaces;
}
</style>
